Vue.component('the-callback-modal', {
    data() {
        return {
            submitInProcess: false,
            response: '',
            callback__modal_response_active: false,
            form: {
                phone: null,
                name: null,
                commentary: null
            }
        }
    },
    computed: {
        opened() {
            return store.state.openedCallbackModal
        }
    },
    watch: {
        opened(val) {
            if (val) {
                let $self = this;
                setTimeout(function() {
                    $self.$refs.input.focus()
                }, 50)
            }
        }
    },
    methods: {
        close() {
            store.dispatch('setCallbackModal', false);
            this.callback__modal_response_active = false
        },
        open() {
            store.dispatch('setCallbackModal', true);
            this.callback__modal_response_active = false
        },
        submit() {
            if (!this.submitInProcess) {
                this.submitInProcess = true;
                let $self = this;
                let data = JSON.parse(JSON.stringify(this.form));
                CsrfHelper.addCsrf(data);
                axios.post('/site/send-callback', data).then(function (response) {
                    $self.callback__modal_response_active = true;
                    $self.response = response.data.message;
                    $self.submitInProcess = false;
                    console.log(response);
                });
            }
        }
    },
});